import http from "../http-common";
// var qs = require("qs");

//GET ALL CATEGORIES
// used in BookList.jsx, EditBookDetails.jsx, MaterialEditBook.jsx, CategoryList.jsx; commented out in BrowseByCategory.jsx
const getAll = () => {
  return http.get("/categories");
};

// used in MaterialAddBook.jsx
const getAllInDomain = (domainId) => {
  return http.get(`/domain/${domainId}/categories`);
};

//GET ALL RELATIONS
// const getRelations = () => {
//   return http.get("/categories/relations");
// };

//FIND CATEGORY BY NAME
// used in Booklist.jsx
const findByName = (name) => {
  return http.get(`/categories/name/${name}`);
};

//FIND BOOKS IN CATEGORY
// commented out in BookList.jsx
const findBooksInCategory = (cat_id) => {
  return http.get(`/categories/booksin/${cat_id}`);
};

//ADD CATEGORIES FOR BOOK
// const addRelations = (data) => {
//   return http.post(`/categories/relations`, data);
// };

//GET CATEGORIES FOR BOOK
// used in MaterialAddBook.jsx, EditBookDetails.jsx
const getCategoriesForBook = (book_id) => {
  return http.get(`/categories/withbook/${book_id}`);
};

//GET FULL CATEGORY DETAILS FROM ID ARRAY
// const getCategoriesFromIds = (arr) => {
//   return http.post(`/categories/details`, arr);
// };

//ADD CATEGORIES FOR BOOK
// used in MaterialAddBook.jsx, EditBookDetails.jsx
const updateBookCategories = (book_id, categories) => {
  console.log("book_id: " + book_id);
  console.log("categories: " + JSON.stringify(categories));
  return http.post(`/categories/${book_id}/update`, categories);
};

//ADD NEW CATEGORY
// used in CategoryModal.jsx
const addNewCategory = (data) => {
  return http.post(`/categories`, data);
};

//DELET CATEGORY
// used in CategoryItem.jsx, GroupsModal.jsx
const deleteCategory = (id) => {
  return http.delete(`/categories/${id}`);
};

// used in CategoryModals.jsx, GroupsModal.jsx
const updateCategory = (id, data) => {
  return http.put(`/categories/${id}`, data);
};

// const updateOrderForCategory = (catId, order_num) => {
//   return http.put(`/categories/${catId}/order/${order_num}`);
// };

// used in CategoryModals.jsx
const uploadNewGroup = (newGroup) => {
  return http.post(`/categorygroup`, newGroup);
};

// used in CategoryList.jsx
const getAllCategoryGroups = () => {
  return http.get(`/categorygroups`);
};

//  used in GroupsModal.jsx
const getAllCategoryGroupsInDomain = (domainId) => {
  return http.get(`/domain/${domainId}/categorygroups`);
};

// used in GroupsModal.jsx
const updateCategoryGroup = (data) => {
  return http.put(`/categorygroup`, data);
};

// used in GroupsModal.jsx
const deleteCategoryGroup = (id) => {
  return http.delete(`/categorygroups/${id}`);
};

const CategoryDataService = {
  getAll,
  // getRelations,
  findByName,
  findBooksInCategory,
  // addRelations,
  getCategoriesForBook,
  // getCategoriesFromIds,
  updateBookCategories,
  addNewCategory,
  deleteCategory,
  updateCategory,
  getAllInDomain,
  // updateOrderForCategory,
  uploadNewGroup,
  getAllCategoryGroups,
  getAllCategoryGroupsInDomain,
  updateCategoryGroup,
  deleteCategoryGroup,
};

export default CategoryDataService;
